import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ApiService } from 'src/app/services/api.service';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal } from 'src/app/models/form-group.model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
export interface DisplayColumn { name: string; property: string; visible: boolean }

@Component({
  selector: 'fury-plan-type-list',
  templateUrl: './plan-type-list.component.html',
  styleUrls: ['./plan-type-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PlanTypeListComponent implements OnInit, OnDestroy {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input() columns: DisplayColumn[] = [
    { name: 'Drag Icon', property: 'drag', visible: true },
    { name: 'Title', property: 'name', visible: true },
    { name: 'Actions', property: 'actions', visible: true }
  ] as DisplayColumn[];
  pageSize = 30;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort; itemList: any; filterValue: any;
  @ViewChild('dataTable') table!: MatTable<any[]>;
  dragDisabled = true;
  imageBasePath!: string; selection = new SelectionModel<any>(true, []);
  pageIndex: number = 0;
   totalCount: number = 0; 
   searchedKeyword!: string;
   searchBy: string = 'title';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  ngUnsubscribe = new Subject<void>();

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.filterValue = 'Property Type';
    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30; 
      this.searchBy = res.searchBy ? res.searchBy : 'title';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
    })
  }

  get visibleColumns() {
    return this.columns.filter((column: DisplayColumn) => column.visible).map((column: DisplayColumn) => column.property);
  }
  ngOnInit(): void { 
    this.getPlanTypeList(); 
  }

  
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/plan-management/plan-type/plan-type-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getPlanTypeList();
  }


  getPlanTypeList(): void {
    this.apiservice.get(`admin/plan/property-type/get-property-types?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.itemList = res.body.planPropertyTypes.data;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
          this.totalCount = res.body.planPropertyTypes.total;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deletePlanType(type: string, value: any): void {
    const obj = { width: '500px', data: { type, value } }
    const dialogref = this.dialog.open(ContentActionComponent, obj);
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiservice.delete(`admin/plan/property-type/delete-property-type/${value.planPropertyTypeId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (del: HttpResponse<any>) => {
              if (del.status === 200) {
                this.apiservice.alert(del.body.message, ErrorType.Success);
                this.getPlanTypeList();
              }
            }, error: (err: HttpErrorResponse) => { if (err) this.apiservice.alert(ErrorText.SomeThingWentWrong, ErrorType.Error) }
          });
      }
    });
  }

  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(`/plan-management/plan-type/plan-type-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getPlanTypeList();
  }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: any[] = [
    {title: 'Title', value: 'title'},
  ];
  searchTypeValue: any[] = [
    {title: 'Contains', value: 'contains'},
    {title: 'Starts With', value: 'startsWith'},
    {title: 'Not Contains', value: 'notContains'},
    {title: 'End With', value: 'endWith'},
    {title: 'Equals', value: 'equals'},
    {title: 'Not Equals', value: 'notEquals'},
  ]
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/plan-management/plan-type/plan-type-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getPlanTypeList();
  };

  drop(event: CdkDragDrop<any[]>) {
    const previousIndex = this.dataSource.data.findIndex(row => row === event.item.data);
    moveItemInArray(this.dataSource.data,previousIndex, event.currentIndex);
    this.table.renderRows();
    const propertyTypeIdList = this.dataSource.data.map((e:any)=> e.planPropertyTypeId)
    this.reArrangeList(propertyTypeIdList); 
  };
  reArrangeList(idList:any){
    this.dragDisabled = true;
    this.apiservice.patch('admin/plan/property-type/rearrange-property-types', {planPropertyTypeIDs: idList}).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res?.body){
        this.dragDisabled = true;
      }
    }, err =>{
      if(err?.message === 'The Input Array Count Must Be Same As All Items Count'){
        this.getPlanTypeList();
        this.apiservice.alert('Please Select All option from bottom pagination', 'error');
      }
    })
  };
  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

}
